export default "__VITE_ASSET__Bn$3sUIk__"